import { Dispatch, SetStateAction, useMemo } from "react"
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { TestResultForm } from "../../types"
import { TeamMember } from "../../../../../types"
import { getFullNameOrEmail } from "../../../../../redux/user"

type TeamMemberField = {
  teamMembers: TeamMember[],
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const TeamMemberField = (props: TeamMemberField) => {
  const { teamMembers, formData, setFormData } = props

  const handleChange = (event: SelectChangeEvent<string>) => {
    const nextForm = structuredClone(formData)

    const value = Number(event.target.value)
    const testedBy = value || null

    nextForm.tested_by = testedBy

    setFormData(nextForm)
  }

  const label = 'Team Member *'
  const value = String(formData.tested_by ?? '')
  const placeholder = 'Select Team Member'

  const options = useMemo(() => {
    return teamMembers
      .toSorted((a, b) => (a.firstname ?? '').toLowerCase().localeCompare((b.firstname ?? '').toLowerCase()))
  }, [teamMembers])

  return (
    <Box>
      <FormControl fullWidth size="small" sx={{ width: '95%' }}>
        <InputLabel>
          { label }
        </InputLabel>
        <Select
          value={value}
          label={label}
          onChange={(event) => handleChange(event)}
          placeholder={placeholder}
        >
          {
            options.map(option => {
              return (
                <MenuItem key={option.login_user_id} value={option.login_user_id}>
                  { getFullNameOrEmail(option) }
                </MenuItem>
              )
            })
          }
        </Select>
      </FormControl>
    </Box>
  )
}

export default TeamMemberField
